// role-cleaner.service.ts
import { Injectable, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class RoleCleanerService implements OnDestroy {
  private observer: MutationObserver;
  private debounceTimeout: any;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.observer = new MutationObserver(() => {
      this.scheduleCleanup();
    });
  }

  init(): void {
    const targetNode = this.document.body;

    // Start observing for dynamic content
    this.observer.observe(targetNode, {
      childList: true,
      subtree: true
    });

    // Initial cleanup on load
    this.cleanRoles();
  }

  private scheduleCleanup(): void {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.cleanRoles();
    }, 50); // Adjust delay based on how dynamic your app is
  }

  private cleanRoles(): void {
    const wrappers = this.document.querySelectorAll('p-button[role="button"], p-button[aria-label]');
    wrappers.forEach((el) => {
      if (el.querySelector('button')) {
        el.removeAttribute('role');
        el.removeAttribute('aria-label');
      }
    });
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  cleanup(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }
}
